import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import sanitizeHTML from "sanitize-html";
import getTrackerName from "./utils/ga-tracker";
// import WebSocket from "./plugins/websocket.js";

import "@/global/components.js";
import "@/global/directives.js";
import "@/global/mixins.js";

import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
// import ActionTracking from "@/core/components/gethelp/utils/actionTracking.js";

// Vue.prototype.$customer = ActionTracking;
// import "@/global/plugins.js";

Vue.config.productionTip = false;
Vue.prototype.$sanitize = sanitizeHTML;

const EventBus = new Vue()
Vue.prototype.$eventBus = EventBus

if (process.env.NODE_ENV === "production") {
  // const d = new Date();
  // eslint-disable-next-line no-console
  console.log(`Built date: ${process.env.VUE_APP_BUILD_TIME}`);
}

if (
  process.env.VUE_APP_SENTRY_ENABLED === "true" &&
  process.env.VUE_APP_SENTRY_DSN &&
  process.env.VUE_APP_SENTRY_DSN.length > 0 &&
  process.env.VUE_APP_ENV !== "local"
) {
  Sentry.init({
    Vue,
    environment: process.env.VUE_APP_ENV,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    ],
    tracesSampleRate: process.env.VUE_APP_TRACES_SAMPLE_RATE,
  });
}
// đoạn này để hiển thị các thông điệp chúc mừng khi mở console
// eslint-disable-next-line no-console
// console.info(`%cHappy Women's Day`, "color: #ffffff;font-size: 60px;font-weight: bold;background: url('https://uploads-ssl.webflow.com/5f31182531574c2df4614c01/5f7fd451aada5e5da471fd53_logo.svg') bottom right no-repeat, url('https://i.pinimg.com/originals/d0/d7/69/d0d769deceddb4de5d454e3460dacde5.jpg') center;background-size: 120px 25px, 100% 100%;background-repeat: no-repeat;padding: 80px 70px 80px 70px;border-radius: 5px; text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #e45b9f, 0 0 40px #e60073, 0 0 50px #e45b9f, 0 0 60px #e60073, 0 0 70px #e45b9f;position: relative;text-align: center;");

new Vue({
  // WebSocket,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");

if (window && window.ga) {
  router.afterEach((to) => {
    const trackerName = getTrackerName();
    const queryString = new URLSearchParams(to.query).toString();
    window.ga(`${trackerName}.set`, 'page', `${to.path}?${queryString}`);
    window.ga(`${trackerName}.send`, 'pageview');
  });
}
